import { fetchBankInfo } from '@/lib/api';

export default {
  state: {
    bankInfo: {},
  },

  getters: {
    bankInfo(state) {
      return state.bankInfo;
    },
  },

  mutations: {
    updateBankInfo(state, bankInfo) {
      state.bankInfo = bankInfo;
    },
  },

  actions: {
    async fetchBankInfo({ commit }, bankNumbers) {
      const bankInfo = await fetchBankInfo.execute(bankNumbers);
      commit('updateBankInfo', bankInfo);

      return bankInfo;
    },
  },
};
